/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const tis: CommunityData = {
  code: "tis",
  inviteCode: "t3l3port2space",
  name: "Teleport into space",
  thumbnail: "https://media.werz.at/web/tis-thumbnail.jpg",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/tis-101`,
  socials: {
    instagramLink: "",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#32353E",
      alternativeLogo: {
        src: "/assets/customizations/tis/white-logo.svg",
        styles: "w-[144px]",
      },
      logo: {
        src: "/assets/customizations/tis/logo.svg",
        styles: "w-[256px] h-[88px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#420400",
      asideStyles: "",
      asideBg: "#1E1E1E",
      contentBg: "#EBEBEB",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/tis/tis-bg.png",
      bgMobile: "/assets/customizations/tis/tis-auth-bg.png",
      nonMemberBg: "/assets/customizations/tis/tis-auth-bg.png",
      mainFont: "font-['BaronNeue']",
      primaryButton:
        "w-full sm:w-fit h-12 bg-[#1E1E1E] !px-6 !text-base !leading-[1] font-['BaronNeue'] !font-black !text-white whitespace-nowrap uppercase rounded-[4px] !pt-[4px]",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#ffffff",
      separator: "border-[#4F4948] border-t",
      item: "font-['BaronNeue'] text-[18px] leading-[18px] h-[40px] flex items-center sm:justify-start justify-center uppercase text-white font-black !pt-2",
      itemSelected: "bg-[#333333] text-white",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles:
        "font-['BaronNeue'] uppercase text-[#1E1E1E] text-[24px] font-black leading-[24px] pb-2",
      announcements: {
        customBg: "bg-[#000000]",
        lg: {
          title: "text-[20px] sm:text-[20px] leading-[1] font-bold mb-1",
          subtitle: "text-[14px] leading-[1] font-medium text-[#F0F5EB] font-['BigShoulders']",
        },
        sm: {
          title: "text-[20px] sm:text-sm leading-[1] mb-2",
          subtitle: "text-[14px] leading-[1] font-medium text-[#F0F5EB] font-['BigShoulders']",
        },
      },
      event: {
        title: "text-base !font-black leading-[0.8] sm:leading-[1] text-[#1E1E1E]",
        subtitle: "text-base leading-[20px] text-[#1E1E1E] !font-normal font-['BigShoulders']",
      },
      shop: {
        title: "text-[20px] leading-[1] font-black font-['BaronNeue'] text-[#1E1E1E]",
        text: "text-base leading-5 text-[#1E1E1E] font-['BigShoulders']",
        customShopImage: "/assets/customizations/tis/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-['BaronNeue'] uppercase text-[#1E1E1E] text-[32px] font-black leading-[32px]",
      title:
        "font-['BaronNeue'] uppercase text-[#1E1E1E] text-[24px] font-black leading-[24px] pb-2",
      description: "text-[14px] leading-[1] font-medium text-[#F0F5EB] font-['BigShoulders']",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title:
        "font-['BaronNeue'] uppercase text-[#1E1E1E] text-[24px] font-black leading-[24px] pb-2",
      description: "text-[14px] leading-[1] font-medium text-[#F0F5EB] font-['BigShoulders']",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle: "text-[32px] font-bold leading-10 font-['BaronNeue'] text-[#1E1E1E] uppercase",
      sectionSubtitle: "text-[20px] leading-6 font-normal text-[#1E1E1E] font-['BigShoulders']",
      text: "text-[20px] leading-6 text-[#1E1E1E] font-['BigShoulders']",
      separator: "border-b border-[#1E1E1E] border-opacity-40",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#1E1E1E",
        strokeColor: "border-[#1E1E1E]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "text-[32px] font-black leading-10 font-['BaronNeue'] text-[#1E1E1E] uppercase",
        subtitle: "text-[20px] leading-6 font-normal text-[#1E1E1E] font-['BigShoulders']",
      },
      ticket: {
        counterContainer: "",
        title: "text-[24px] uppercase leading-7 font-black font-['BaronNeue'] text-[#1E1E1E]",
        description: "text-base leading-5",
        text: "text-base leading-5 text-[#1E1E1E] font-['BigShoulders']",
        price: "text-[24px] leading-7 font-black text-[#1E1E1E]",
        quantity: "text-[20px] leading-5 font-bold text-[#1E1E1E]",
      },
    },
  },
}

export default tis
